import keyMirror from 'keymirror';
import { nameInUrlFormat, withLanguageLocale } from '../../services/Helper';

export const topicDetailsActionTypes = keyMirror({
	GET_TOPIC_DETAILS: null,
	GET_TOPIC_DETAILS_SUCCESS: null,
	GET_TOPIC_DETAILS_ERROR: null,

	GET_TOPIC_RELATED_QUESTIONS: null,
	GET_TOPIC_RELATED_QUESTIONS_SUCCESS: null,
	GET_TOPIC_RELATED_QUESTIONS_ERROR: null,

	GET_TOPIC_EXERCISE: null,

	CLEAN_TOPIC_DETAILS_STATE: null,
});

export const getTopicDetailsTabs = (topicId, title, t) => [
	{
		title: t('topic_details.tabs.details'),
		value: '',
		link: withLanguageLocale(`/topics/${topicId}/${nameInUrlFormat(title)}`),
		index: 0,
	},
	{
		title: t('topic_details.tabs.results'),
		value: 'results',
		link: withLanguageLocale(`/topics/${topicId}/${nameInUrlFormat(title)}/results`),
		index: 1,
	},
];
